<ui-card-page brand="Werfy Admin Portal">
  <router-outlet></router-outlet>
</ui-card-page>
